// extracted by mini-css-extract-plugin
export var addressFields = "_pe-0";
export var animationContainer = "_pe-1";
export var footer = "_pe-2";
export var lineItems = "_pe-3";
export var modalContent = "_pe-4";
export var orderName = "_pe-5";
export var strong = "_pe-6";
export var warning = "_pe-7";